<template>
    <navigation-header-akademia2 v-if="variant === 'akademia2'"/>
    <navbar v-else ref="navbar" placement="static" type="default" :class="{ 'guest-navbar' : !isAuthenticated }">
        <router-link slot="brand" class="navbar-brand" to="/item-dashboard">
            <img v-if="isAuthenticated" src="~variantImages/logo_navbar.png"
                 class="logo-navbar"
            />
            <img v-else src="~variantImages/logo_navbar_guest.png"
                 class="logo-navbar"
            />
        </router-link>

        <!-- The navbar links - taken from config because of variants.
            "dropdown" class is necessary, otherwise vue-strap will cause the nav-items work intermittently
            on mobile, sometimes just closing the menu on click. -->
        <template v-if="isAuthenticated">
            <li v-for="(navbarItem, index) in navbarItems" :key="index"
                class="nav-item dropdown"
                :class="[navbarItem.class, { active: isActiveRoute(navbarItem.route) }]"
            >
                <router-link :to="navbarItem.route" exact class="nav-link" @click.native="handleNavClick">
                    {{ navbarItem.langKey | translate }}
                </router-link>
            </li>
        </template>

        <li class="nav-item user-info dropdown" slot="right"
            v-if="isAuthenticated && showUserInfo"
        >
            <div class="user-info-content-wrapper"
            >
                <li @click="handleUserInfoClick">
                    <a class="nav-link">{{ user.name }}</a>
                    <a class="user-points"
                         v-if="currentProgress"
                    >{{ 'POINTS_COUNT' | translate }}: {{ currentProgress.score }}</a>
                </li>
            </div>
        </li>

        <li slot="right" class="logout" v-if="isAuthenticated">
            <a class="nav-link" @click="logout()">
                <i class="fa fa-power-off"></i> {{ 'LOGOUT' | translate }}
            </a>
        </li>

        <li slot="right" v-if="!isAuthenticated">
            <p class="navbar-btn">
                <button class="btn brand-primary-btn" @click="onLoginButton">
                    {{ 'LOGIN' | translate }}
                </button>
            </p>
        </li>

        <li slot="right" v-if="!isAuthenticated && !ssoEnabled">
            <a class="nav-link" @click="scrollToRegistration">
                {{ 'REGISTRATION' | translate }}
            </a>
        </li>
    </navbar>
</template>
<!---------------------------------------------------------------------------->
<script>
    import navbar from "vue-strap/src/Navbar.vue";
    import { mapGetters } from "vuex";

    import urlService from "src/services/urlService";

    import log from "src/services/logger";
    const logTag = "Navigation";

    export default {
        components : {
            navbar,
            NavigationHeaderAkademia2: VARIANT === 'akademia2'
                ? () => import("./NavigationHeaderAkademia2.vue")
                : null,
        },
        computed : mapGetters([ "isAuthenticated", "user", "route", "currentProgress" ]),
        data() {
            return {
                ssoEnabled          : config.features.ssoLogin,
                navbarItems         : config.navbarItems,
                showUserInfo        : config.showUserInfo,
                variant             : VARIANT,
            };
        },
        methods : {
            logout() {
                log.log(logTag, "Logout clicked");
                this.$store.dispatch("sendLogoutRequest").then(() => {
                    this.$router.push("/login").catch(() => {});
                });
            },

            isActiveRoute(route) {
                // Check if the current route matches the navbar item route
                return this.$route.path === route;
            },

            handleNavClick() {
                // Close mobile menu after navigation on small screens
                if (window.innerWidth < 768) {
                    // Access the navbar component and close it
                    setTimeout(() => {
                        if (this.$refs.navbar) {
                            this.$refs.navbar.collapsed = true;
                        }
                    }, 100); // Small delay to allow navigation to start
                }
            },

            handleUserInfoClick(event) {
                // Prevent event bubbling to avoid conflicts
                event.stopPropagation();

                // Only navigate if we're not already on the profile page
                if (this.$route.path !== "/profile") {
                    this.$router.push("/profile").catch(err => {
                        log.log(logTag, "Navigation error:", err);
                    });
                }

                // Use the same mobile menu closing logic
                this.handleNavClick();
            },

            onLoginButton() {
                if (this.ssoEnabled) {
                    log.log(logTag, "SSO login button pressed");

                    // if there are any params in the URL (e.g. area, category) we need to remember them
                    // before we redirect to SSO
                    urlService.storeUrlParams();

                    // We just redirect the user to SSO url, which will handle logging in and will return to
                    // this app by calling /token/:token router. App's router then handles the rest.
                    window.location.href = config.api.base + config.sso.url;
                } else {
                    this.scrollToLogin();
                }
            },

            // If the navbar's Login or Register links are pressed while user is on Login page, the Login's
            // mounted() will not be called and the navbar will change the component and scroll
            // If the user is not on Login page, navbar's links will redirect there and Login will change
            // the component and scroll in its mounted()
            scrollToLogin() {
                this.$store.dispatch("changeLoginComponent", "LoginForm");
                this.$scrollTo("#user-auth-area", 400, {});
                this.$router.push("/login/login");
            },

            scrollToRegistration() {
                this.$store.dispatch("changeLoginComponent", "RegistrationForm");
                this.$scrollTo("#user-auth-area", 400, {});
                this.$router.push("/login/registration");
            }
        }
    };
</script>
<!---------------------------------------------------------------------------->
<style lang="scss" type="text/scss">
</style>
